import { Table } from 'antd';
import {
	Pagination,
	PagingConfig,
	UserRole,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { tablePaginationConfiguration } from '../../../shared/Utils';
import { FunctionaryTableColumns } from './FunctionaryTableColumns';
import { NavigateOptions } from 'react-router-dom';
import { PositionAssignmentFilters } from './FilterFunctionaries';
import { PositionAssignmentUser } from '../../../shared/MySrcm';

interface FunctionaryTableProps {
	functionaries: PositionAssignmentUser[] | undefined;
	pagination: Pagination;
	paging: PagingConfig;
	onPageChange: (page: number, pageSize: number) => void;
	navigateWithFunctionarySrcmId: (
		route: string,
		functionarySIdParam?: string,
		params?: NavigateOptions
	) => void;
	onFilterChange: (filters: PositionAssignmentFilters) => void;
}

export const FunctionaryTableView = (props: FunctionaryTableProps) => {
	const {
		functionaries,
		paging,
		pagination,
		onPageChange,
		navigateWithFunctionarySrcmId,
		onFilterChange,
	} = props;

	const tablePaginationConfig = tablePaginationConfiguration(
		paging,
		pagination,
		onPageChange
	);

	const columns = FunctionaryTableColumns({
		navigateWithFunctionarySrcmId,
		onFilterChange,
	});

	const filteredData = functionaries?.filter((record) => {
		return record.assignments?.some(
			(a) =>
				a.assign_active &&
				a.position?.code &&
				a.position.code !== UserRole.APP_ROLE_ADMIN
		);
	});

	return (
		<>
			<>
				<Table
					columns={columns}
					dataSource={filteredData}
					pagination={tablePaginationConfig}
					scroll={{ x: 'max-content' }}
					rowClassName={() => 'border-b border-gray-300 bg-white'}
					className="w-full overflow-x-auto !border-separate !border-spacing-y-0"
				/>
			</>
		</>
	);
};
